export const search = {
	name: 'search',
	title: 'Search',
	content:
		'<path d="M 6.268,1.471c4.607-1.958,9.928,0.19,11.886,4.796s-0.19,9.928-4.796,11.886s-9.928-0.19-11.886-4.796 S1.662,3.429,6.268,1.471z " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 16.221,16.22l7.029,7.03" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
